import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssignmentIndFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.081 1.25C9.54912 1.25 9.04698 1.49157 8.71483 1.90588L7.63953 3.25H6C4.48079 3.25 3.25 4.48079 3.25 6V19C3.25 20.5192 4.48079 21.75 6 21.75H18C19.5192 21.75 20.75 20.5192 20.75 19V6C20.75 4.48079 19.5192 3.25 18 3.25H16.3606L15.2868 1.9067L15.2862 1.90588C14.954 1.49156 14.4519 1.25 13.92 1.25H10.081ZM9 5.25C8.86221 5.25 8.75 5.13779 8.75 5H7.25C7.25 5.96621 8.03379 6.75 9 6.75H15C15.9662 6.75 16.75 5.96621 16.75 5H15.25C15.25 5.13779 15.1378 5.25 15 5.25H9ZM14.5 10.5C14.5 9.11667 13.3833 8 12 8C10.6167 8 9.5 9.11667 9.5 10.5C9.5 11.8833 10.6167 13 12 13C13.3833 13 14.5 11.8833 14.5 10.5ZM17 18V16.8333C17 15.1667 13.6667 14.25 12 14.25C10.3333 14.25 7 15.1667 7 16.8333V18H17Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgAssignmentIndFilled);
export default ForwardRef;
